import { Expose, Transform, Type } from 'class-transformer'

import { Base } from './Base'
import { Pallet } from './Pallet'
import { Shipment } from './Shipment'

export class ShipmentPallet extends Base {
  @Expose({ name: 'pallet' })
  @Transform(({ pallet }) => pallet?.guid)
  guid: string = ''

  @Type(() => Shipment)
  shipment?: Shipment

  @Type(() => Pallet)
  pallet?: Pallet
}
